import { useCallback, useEffect, useMemo, useState } from 'react'

const wordSegments = (text: string) => text.trim().split(/\s+/).filter(Boolean)

const useReadMore = (text: string, numberOfWordsToDisplay = 20) => {
  const { fullText, previewText, isTruncatable } = useMemo(() => {
    const words = wordSegments(text)
    if (words.length <= numberOfWordsToDisplay) {
      return { fullText: text, previewText: text, isTruncatable: false }
    }
    return {
      fullText: text,
      previewText: words.slice(0, numberOfWordsToDisplay).join(' '),
      isTruncatable: true,
    }
  }, [text, numberOfWordsToDisplay])

  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    setIsExpanded(false)
  }, [text, numberOfWordsToDisplay])

  const handleClickReadMore = useCallback(() => {
    setIsExpanded(true)
  }, [])

  const isFold = isTruncatable && !isExpanded
  const displayedText = isFold ? previewText : fullText

  return { handleClickReadMore, isFold, displayedText }
}

export default useReadMore
